import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";

import { useLocation } from "react-router";

import MapTool from "@mapmycustomers/shared/enum/map/MapTool";
import { Territory } from "@mapmycustomers/shared/types/entity";

import ExtendedAnalytics from "@app/component/analytics/ExtendedAnalytics";
import Banner from "@app/scene/map/components/TerritoriesMode/components/banner";
import SelectionHint from "@app/scene/map/components/TerritoriesMode/components/SelectionHint";
import LassoToolPanel from "@app/scene/map/components/tools/LassoToolPanel";
import { selectMapTool } from "@app/scene/map/store/actions";
import { getMapViewTool } from "@app/scene/map/store/mapMode/selectors";
import { getTerritory, getTerritoryMode } from "@app/scene/map/store/territoryMode/selectors";
import TerritoryModeState from "@app/scene/map/store/territoryMode/TerritoryModeState";
import { RootState } from "@app/store/rootReducer";

import FilterBar from "./FilterBar";
import styles from "./TopPanel.module.scss";

interface Props {
  mode: TerritoryModeState["mode"];
  selectMapTool: typeof selectMapTool;
  territory?: Territory;
  tool?: MapTool;
}

const TopPanel: React.FC<Props> = ({ mode, selectMapTool, territory, tool }) => {
  const { search } = useLocation();
  const hasAreaType = useMemo(() => {
    if (search) {
      const urlParams = new URLSearchParams(search);
      return urlParams.has("areaType");
    }
    return false;
  }, [search]);

  const handleExitLasso = useCallback(() => selectMapTool(undefined), [selectMapTool]);
  const isLassoMode = tool === MapTool.LASSO;

  const showHint =
    (mode === "create" && hasAreaType) ||
    (mode === "edit" && territory && territory.territoryDetail.type !== "points");

  return (
    <div className={styles.container}>
      {isLassoMode ? <LassoToolPanel onExit={handleExitLasso} /> : <Banner />}

      {!tool && (
        <div className={styles.filters}>
          <ExtendedAnalytics keyPath="Filters">
            <FilterBar />
          </ExtendedAnalytics>
          {showHint && <SelectionHint className={styles.hint} />}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  mode: getTerritoryMode(state),
  territory: getTerritory(state),
  tool: getMapViewTool(state),
});

const mapDispatchToProps = {
  selectMapTool,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopPanel);
